const LOCAL_STORAGE_KEY = {
    TOKEN: 'autentika_app_token'
}


export default LOCAL_STORAGE_KEY;